let pending

export function loadDingTalkSdk() {
  if (window.dd) return Promise.resolve(window.dd)
  if (!pending) {
    pending = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.src = 'https://g.alicdn.com/dingding/dingtalk-jsapi/3.1.0/dingtalk.open.js'
      script.onload = () => resolve(window.dd)
      script.onerror = () => reject(new Error('钉钉 JSAPI 加载失败，请检查网络。'))
      document.head.appendChild(script)
    }).catch(error => { pending = null; throw error })
  }
  return pending
}
